import styled from 'styled-components';

export const StepperContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
`;

export const StepsContainer = styled.div<{ $width: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: ${({ $width }) => $width};
`;

export const StepWrapper = styled.div`
  position: relative;
`;

export const Step = styled.div<{ isActive: boolean }>`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: ${({ isActive }) =>
    isActive ? 'rgba(32, 154, 214, 1)' : '#6b7280'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin: 5px;
`;

export const StepLabel = styled.div`
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap; /* Prevent text from wrapping */
`;

export const StepSeparator = styled.div<{ isActive: boolean }>`
  width: 100%;
  height: 2px;
  background-color: ${({ isActive }) =>
    isActive ? 'rgba(32, 154, 214, 1)' : '#6b7280'};
  margin: 0 10px;
`;
